<template>
	<div v-loading="loading" :style="{
	 	minHeight: equipment == 'pc'?'500px':'100vh'
	 }" style="user-select:text;">
		<div v-if="equipment == 'pc'">
			<div v-for="(good,goodIndex) in wishlist" :key="goodIndex"
				style="width:90%;border: solid 1px #d8d8d8;display: flex;align-items: center;margin-top: 20px;">
				<div style="width: 50%;display: flex;align-items: center;padding: 20px;">
					<img :src="good.image" style="width:58px;height: 58px;">
					<div class="tit tit-hover" style="margin-left: 20px;font-size: 14px;" @click="navTo(good)">
						{{good.product_name}}
					</div>
				</div>
				<div
					style="margin-left: 10px;height: 58px;width: 50%;display: flex;align-items: center;justify-content: space-between;">
					<div>{{good.price}}</div>
					<div
						style="display: flex;flex-direction: column;justify-content: space-between;padding-right: 10px;">

						<el-button class="btn" style="width: 140px;margin-left: 10px;" size="mini"
							@click="cancelWishlist(good)">{{$t('h.wishlist')}}</el-button>
						<el-button class="btn-ok" style="width: 140px;margin-left: 10px;margin-top: 10px;" size="mini"
							@click="navTo(good)">{{$t('h.look')}}</el-button>
					</div>
				</div>
			</div>
		</div>

		<div v-if="equipment == 'phone'">
			<div v-for="(good,goodIndex) in wishlist" :key="goodIndex"
				style="width:98%;border: solid 1px #d8d8d8;display: flex;align-items: center;margin-top: 20px;">
				<div style="width: 50%;display: flex;align-items: center;padding: 10px;">
					<img :src="good.image" style="width:58px;height: 58px;">
					<div style="max-width: calc(100% - 58px);">
						<div  class="tit" style="margin-left: 20px;width: 60px;">{{good.price}}</div>
						<div class="tit tit-hover" style="margin-left: 20px;font-size: 14px;margin-top: 10px;width: 60px;" @click="navTo(good)">
							{{good.product_name}}
						</div>
					</div>
				</div>
				<div
					style="margin-left: 10px;height: 58px;display: flex;align-items: center;justify-content: space-between;">
					<div
						style="display: flex;flex-direction: column;justify-content: space-between;padding-right: 10px;">
						<el-button class="btn" style="width: 140px;margin-left: 6px;font-size: 12px;" size="mini"
							@click="cancelWishlist(good)">{{$t('h.wishlist')}}</el-button>
						<el-button class="btn-ok" style="width: 140px;margin-left: 6px;margin-top: 10px;font-size: 12px;" size="mini"
							@click="navTo(good)">{{$t('h.look')}}</el-button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getaccountOrders,
		getaccountOrderItem,
		getaccountOrderCancel,
		getaccountWishlistData,
		getCancelWishlistData
	} from '../../../../api/all.js'
	export default {
		props: {
			equipment: {
				type: String,
				default: "pc"
			},
			localPageData: {
				type: Object,
				default: () => {
					return {}
				}
			},
		},
		data() {
			return {
				wishlist: [],
				detailLoading: false,
				selectItem: null,
				dialogVisible: false,
				loading: false,
				activeName: "first",
				tabs: [{
						name: "first",
						label: this.$t('h.allOrder'),
						page: 1,
						data: {}
					},
					{
						page: 1,
						status: 'unpaid',
						name: "second",
						label: this.$t('h.waitPay'),
						data: {}
					},
					{
						page: 1,
						status: 'paid',
						name: "third",
						label: this.$t('h.waitSend'),
						data: {}
					},
					{
						page: 1,
						status: 'shipped',
						name: "fourth",
						label: this.$t('h.waitReceiving'),
						data: {}
					},
					{
						page: 1,
						status: 'completed',
						name: "five",
						label:  this.$t('h.completed'),
						data: {}
					}
				]
			}
		},
		async mounted() {
			await this.getData()

		},
		methods: {
			navTo(e) {
				console.log('ee', e)
				this.$router.push({
					path: '/products/' + e.url_name
				})
			},
			async cancelWishlist(item) {
				try {
					this.loading = true
					let data = await getCancelWishlistData({
						id: item.id
					})
					await this.getData()
					this.$message.success(data.data.message)
					this.loading = false
					console.log('data', data)
				} catch (e) {
					this.loading = false
				}
			},
			async getData(reload = false) {
				try {
					this.loading = true
					let data = await getaccountWishlistData()
					this.wishlist = data.data.data.wishlist
					this.loading = false
				} catch (e) {
					this.loading = false
				}

			},
		}
	}
</script>

<style lang="scss" scoped>
	.tit {
		display: -webkit-box;
		/* 设置为WebKit内核的弹性盒子模型 */
		-webkit-box-orient: vertical;
		/* 垂直排列 */
		-webkit-line-clamp: 1;
		/* 限制显示两行 */
		overflow: hidden;
		/* 隐藏超出范围的内容 */
		text-overflow: ellipsis;
	}

	.tit-hover:hover {
		color: #55aaff;
		cursor: pointer;
	}


	.btn {
		background-color: #fff;
		color: #000;
		border: solid 1px #e5e5e5;
	}

	.btn:hover {
		background-color: #fff;
		color: #000;
		border: solid 1px #e5e5e5;
	}

	.btn:focus {
		background-color: #fff;
		color: #000;
		border: solid 1px #e5e5e5;
	}

	.btn-ok {
		background-color: #000;
		color: #fff;
		border: solid 1px #000;
	}

	.btn-ok:hover {
		background-color: #000;
		color: #fff;
		border: solid 1px #000;
	}

	.btn-ok:focus {
		background-color: #000;
		color: #fff;
		border: solid 1px #000;
	}
</style>